<script  lang="ts" setup>
/**
 * UI-kit component
 * Category: Buttons
 * Name: 'Close button'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=314-105800&m=dev'
 */
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons'

import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/icon'

defineOptions({
  name: 'BtnClose',
})

withDefaults(defineProps<BtnCloseProps>(), {
  icon: () => faXmark,
  disabled: false,
  color: 'gray',
  size: 'medium',
  dataQa: null,
})

const emit = defineEmits<{
  click: []
}>()

interface BtnCloseProps {
  icon?: IconDefinition
  disabled?: boolean
  color?: 'gray'
  size?: 'medium' | 'small'
  dataQa?: string | null
}

const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <button
    type="button"
    :class="['ui-btn-close', color, size]"
    :data-qa="dataQa"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      :class="[`ui-btn-close__container container-${size}`]"
    >
      <FontAwesomeIcon
        :icon="icon"
      />
    </IconContainer>
  </button>
</template>

<style scoped lang="scss" src="./BtnClose.scss" />
